<template>
  <div class="base-top-nav-mobile" ref="modalRef">
    <div class="base-top-nav-mobile-trigger" @click="toggleContent()">
      <i class="material-icons icon-trigger">menu</i>
    </div>
    <div :class="['base-top-nav-mobile-content', {'active': showContent}]">
      <router-link to="/" class="top-nav-item">Home</router-link>
      <a href="#what-is-new" class="top-nav-item" @click="goToElement($event,'what-is-new')">What's New</a>
      <router-link to="/events" class="top-nav-item">Adventures & Activities</router-link>
      <router-link to="/events/fitness-and-sport" class="top-nav-item">Fitness & Sport</router-link>
      <router-link to="/events/outdoor-and-trail" class="top-nav-item">Outdoor & Trail</router-link>
      <router-link to="/events/wellness-and-recovery" class="top-nav-item">Wellness & Recovery</router-link>
      <router-link to="/#partners" class="top-nav-item" @click="goToElement($event,'partners')">Partners</router-link>
      <router-link to="/expert-guides" class="top-nav-item">Expert Guides</router-link>
      <router-link to="/faq" class="top-nav-item">F.A.Q.</router-link>
    </div>
  </div>
</template>
<script>
import utility from "@/presentation/mixins/utility.js";
import { isEmpty } from "lodash";
export default {
  name: "BaseTopNavMobile",
  mixins: [utility],
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      brands: [],
      categories: [],
      showContent: false,
    }
  },
  computed: {
    allBrandsActive() {
      let brandParam = this.$route.params.brandCode;
      return !brandParam
    },
    allBrands() {
      return `/shop`;
    },
    currentOutlet() {
      return this.$store.getters.getCurrentOutlet;
    }
  },
  methods: {
    async goToElement(event, elementId) {
      event.preventDefault();
      this.showContent = false;
      const onHome = this.$route.name === "WelcomePage" || this.$route.path === "/";
      if (!onHome) {
        await this.$router.push({ name: "WelcomePage" });
      }
      await this.$nextTick();
      // Router scrollBehavior resets the window after this tick.
      setTimeout(() => this.scrollToElement(elementId), 0);
    },
    scrollToElement(elementId, attempt = 0) {
      const target = document.getElementById(elementId);
      if (!target) {
        if (attempt < 30) {
          requestAnimationFrame(() => this.scrollToElement(elementId, attempt + 1));
        }
        return;
      }
      const scroller = this.getScrollParent(target);
      const nav = document.querySelector(".sd-header .header-con");
      const promo = document.querySelector(".bps-container");
      let headerOffset = 0;
      if (scroller === window && nav) {
        headerOffset = nav.getBoundingClientRect().height;
        const promoWillCollapse = promo
          && !promo.classList.contains("empty")
          && !promo.classList.contains("scrolling")
          && promo.getBoundingClientRect().height > 0;
        if (promoWillCollapse) {
          headerOffset += promo.getBoundingClientRect().height;
        }
      }
      const top = (scroller === window
        ? target.getBoundingClientRect().top + window.scrollY
        : scroller.scrollTop + target.getBoundingClientRect().top - scroller.getBoundingClientRect().top
      ) - headerOffset;
      scroller.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    },
    getScrollParent(element) {
      let parent = element.parentElement;
      while (parent) {
        const overflowY = window.getComputedStyle(parent).overflowY;
        const canScroll = parent.scrollHeight > parent.clientHeight + 1;
        if ((overflowY === "auto" || overflowY === "scroll") && canScroll) return parent;
        parent = parent.parentElement;
      }
      return window;
    },
    itemLink(item) {
      return `/collections/brand/${item.apiCode}`
    },
    categoryLink(item) {
      return `/collections/category/${this.slugName(item)}`
    },
    isActiveBrand(item) {
      let brandParam = this.$route.params.brandCode;
      return item.apiCode == brandParam;
    },
    toggleContent() {
      this.showContent = !this.showContent;
    },
    handleClickOutside(event){
      if (this.$refs.modalRef && !this.$refs.modalRef.contains(event.target)) {
        this.showContent = false
      }
    },
    init(){
      let hq = this.$store.getters.getHeadquarter;
      let allBrands = [];
      if(!isEmpty(hq) && !isEmpty(hq.headquarter)){
        allBrands = hq.headquarter.brand;
      }
      if(!isEmpty(allBrands) && !isEmpty(this.products)){
        allBrands = allBrands.filter((b) => {
          return this.products?.filter((prd) => prd.brands?.map((it) => it.apiCode).includes(b.apiCode)).length > 0;
        });
      }
      this.brands = allBrands;
      this.categories = this.mapProductCategories();
    }
  },
  watch: {
    products: {
      handler() {
        this.init();
      },
      deep: true
    },
  },
  created() {
    this.init()
    document.body.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount(){
    document.body.removeEventListener('click', this.handleClickOutside);
  }
}
</script>
<style scoped lang="scss">
.base-top-nav-mobile {
  // display: none;
  display: flex;
  width: fit-content;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  overflow: visible;
  z-index: 100;
  position: relative;
  .base-top-nav-mobile-trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: fit-content;
    cursor: pointer;
    color: $dark-color-1;
    .icon-trigger {
      font-size: 32px !important;
    }
  }
  .base-top-nav-mobile-content {
    min-width: 300px;
    max-width: 400px;
    display: flex !important;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: fixed;
    top: 0;
    bottom: 0;
    left: -100%;
    background: $white;
    max-height: 100%;
    height: 100%;
    overflow-y: auto;
    transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
    padding: 24px;
    &.active {
      left: 0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    }
  }
}
.list-groups {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  .list-groups-trigger {
    font-weight: bold;
    font-size: 0.9em;
    width: 100%;
    text-align: left;
    padding-block: 4px;
    color: $dark-color-2;
    cursor: pointer;
    position: relative;
    height: 30px;
    margin: 8px 0 0 0;
    &::before {
      content: attr(data-label);
      height: 30px;
      width: calc(100% - 24px);
      position: absolute;
      left: 0;
      pointer-events: none;
      background: $white;
      font-size: 17px;
      font-weight: 600;
      line-height: 26px;
      letter-spacing: 0px;
    }
    &::after {
      position: absolute;
      right: 0;
      content: "arrow_drop_down";
      font-family: "Material Icons Outlined";
      pointer-events: none;
      font-size: 17px !important;
    }
    &:checked {
      & + .list-group-items {
        max-height: unset !important;
      }
    }
  }
  .list-group-items {
    width: 100%;
    padding-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
    overflow: hidden;
    max-height: 0;
    & .top-nav-item {
      padding-block: 0 !important;
    }
  }
}
.top-nav-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 8px;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  width: 100%;
  position: relative;
  min-height: 40px;
  color: $dark-color-2;
  font-size: 17px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0px;
  & .item-link {
    min-height: 40px;
    display: flex;
    align-items: center;
    text-decoration: none;
    font-weight: 400;
    color: $dark-color-2;
    &.bold {
      font-family: 'Berthold Akzidenz Grotesk Medium', sans-serif;
      font-weight: normal !important;
    }
  }
  &.active {
    color: $primary-color-60;
  }
  &.with-trigger {
    padding-block: 0 !important;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    &::after {
      position: absolute;
      right: 0;
      top: 6px;
      content: "arrow_drop_down";
      font-family: "Material Icons Outlined";
      pointer-events: none;
    }
    input {
      height: 30px;
      width: 20px;
      position: absolute;
      right: 0%;
      opacity: 0;
      cursor: pointer;
      &:checked + .list-group-items {
        max-height: unset !important;
      }
    }
  }
  &.block {
    font-family: 'Berthold Akzidenz Grotesk Medium', sans-serif;
    font-weight: normal !important;
    padding-block: 0px !important;
  }
  &.sale {
    font-weight: normal !important;
    font-family: 'Berthold Akzidenz Grotesk Medium', sans-serif;
    color: $main-red;
  }
}
.nav-trigger {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  .material-icons {
    pointer-events: none;
  }
}
.nav-dropdown {
  display: none;
  &.active {
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 0;
    border-radius: 6px;
    background: $white;
    top: 50px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    min-width: 200px;
    z-index: 100;
    overflow: hidden;
  }
  .nav-dropdown-item {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    padding-inline: 16px;
    min-height: 40px;
    text-align: left;
    text-decoration: none;
    color: $secondary-color-90;
    &:hover {
      background: $secondary-color-20;
    }
  }
}
@media (min-width: 672px) {
	.base-top-nav-mobile {
    display: none !important;
    width: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .list-group-items {
    &:hover {
      .top-nav-item:not(:hover):not(.active){
      color: $secondary-color-50;
      }
      .top-nav-item:not(:hover):is(.active){
      color: $primary-color-40;
      }
    }
  }
}
@media (min-width: 672px) and (max-width: 1024px) {
  .base-top-nav-mobile {
    display: flex !important;
    width: fit-content !important;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px;
    overflow: visible !important;
    z-index: 100;
  }
}
/* @media (max-height: 768px) and (max-width: 1024px) {
  .base-top-nav-list {
    display: none !important;
    width: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
} */
</style>
